(function () {
  const sliders = [];
  let resizeTimer;

  const getGridColumnCount = (productsPerRow, productsPerRowMobile, width) => {
    const mobileCols = Number(productsPerRowMobile) === 2 ? 2 : 1;

    if (width < 576) return mobileCols;
    if (width < 990) return 2;
    if (width < 1200) return productsPerRow >= 3 ? 3 : 2;
    if (width < 1360) {
      if (productsPerRow >= 4) return 4;
      if (productsPerRow >= 3) return 3;
      return 2;
    }

    return productsPerRow;
  };

  const getBalancedVisibleCount = (total, cols) => {
    if (total <= 0) return 0;
    if (total <= cols) return total;

    let count = total;
    while (count > cols && count % cols !== 0) {
      count -= 1;
    }

    return count;
  };

  const balanceProductGrid = (layoutEl) => {
    const listEl = layoutEl.querySelector(".popular-products__list--grid");
    if (!listEl) return;

    const productsPerRow = Number(layoutEl.dataset.productsPerRow || 4);
    const productsPerRowMobile = layoutEl.dataset.productsPerRowMobile || "1";
    const items = [...listEl.querySelectorAll(".popular-products__item")];

    if (!items.length) return;

    const cols = getGridColumnCount(
      productsPerRow,
      productsPerRowMobile,
      window.innerWidth
    );
    const visibleCount = getBalancedVisibleCount(items.length, cols);

    items.forEach((item, index) => {
      const hide = index >= visibleCount;
      item.classList.toggle("popular-products__item--balanced-hidden", hide);
      item.toggleAttribute("aria-hidden", hide);
    });
  };

  const balanceProductGrids = (box) => {
    box.querySelectorAll(".popular-products__layout").forEach(balanceProductGrid);
  };

  const initSliders = (section) => {
    const sliderEls = section.querySelectorAll(".js-popular-products-slider");

    sliderEls.forEach((sliderEl) => {
      const swiperWrapper = sliderEl.querySelector(
        ".popular-products__list--slider"
      );
      const slides = sliderEl.querySelectorAll(".popular-products__item");

      if (!swiperWrapper || !slides || !slides.length) return;

      const tabId = sliderEl.dataset.productsTabId;
      const productsPerRow = Number(sliderEl.dataset.productsPerRow || 4);
      const productsPerRowMobile = Number(
        sliderEl.dataset.productsPerRowMobile || 1
      );
      const spaceBetween = Number(sliderEl.dataset.spaceBetween || 1);

      const prevBtn = section.querySelector(
        `.popular-products__navigation[data-products-tab-id="${tabId}"] .heading-group__navigation-button-prev`
      );
      const nextBtn = section.querySelector(
        `.popular-products__navigation[data-products-tab-id="${tabId}"] .heading-group__navigation-button-next`
      );
      const slidesPerViewMobile = productsPerRowMobile;
      const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
      const slidesPerView990 =
        productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
      const slidesPerView1200 = productsPerRow >= 4 ? 4 : productsPerRow;
      const slidesPerView1360 = productsPerRow;

      const sliderSettings = {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: spaceBetween,
        speed: 800,
        watchSlideProgress: true,
        allowTouchMove: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: {
          576: {
            slidesPerView: slidesPerView576,
          },
          990: {
            slidesPerView: slidesPerView990,
          },
          1200: {
            slidesPerView: slidesPerView1200,
          },
          1360: {
            slidesPerView: slidesPerView1360,
          },
        },
      };

      const slider = new Swiper(sliderEl, sliderSettings);
      sliders.push(slider);
    });
  };

  const destroySliders = () => {
    sliders.forEach((slider) => {
      if (typeof slider.destroy === "function") {
        slider.destroy();
      }
    });
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".popular-products__tab");
    const productsEls = section.querySelectorAll(".popular-products__layout");
    const navigationEls = section.querySelectorAll(
      ".popular-products__navigation"
    );

    const onToggleTab = (event, tab) => {
      event.preventDefault();
      if (tab.classList.contains("active")) return;
      const tabId = tab.dataset.productsTabId;

      tabsEls.forEach((el) => {
        el.classList.remove("active", "button--tertiary");
        el.classList.add("button--simple");
      });

      productsEls.forEach((el) => {
        el.classList.remove("active");
      });

      navigationEls.forEach((el) => {
        el.classList.remove("active");
      });

      const productsActiveEl = section.querySelector(
        `.popular-products__layout[data-products-tab-id="${tabId}"]`
      );
      const navigationActiveEl = section.querySelector(
        `.popular-products__navigation[data-products-tab-id="${tabId}"]`
      );
      tab.classList.remove("button--simple");
      tab.classList.add("active", "button--tertiary");
      productsActiveEl.classList.add("active");
      navigationActiveEl.classList.add("active");
      balanceProductGrid(productsActiveEl);
    };

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => onToggleTab(event, tab));

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onToggleTab(event, tab);
        }
      });
    });
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("popular-products-section")) {
      return;
    }

    const box = section.querySelector(".popular-products");
    if (!box) return;

    const layout = box.dataset.layout || "grid";
    if (layout === "slider") {
      initSliders(box);
    } else {
      destroySliders();
      balanceProductGrids(box);
    }

    toggleTab(box);
  };

  const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll(".popular-products-section .popular-products").forEach((box) => {
        if ((box.dataset.layout || "grid") === "grid") {
          balanceProductGrids(box);
        }
      });
    }, 150);
  };

  initProductsTabs(document.currentScript.parentElement);

  document.addEventListener("popular-products:newest-loaded", (event) => {
    const box = event.target.closest(".popular-products");
    if (!box) return;
    const layout = box.dataset.layout || "grid";
    if (layout === "grid") {
      balanceProductGrids(box);
      return;
    }

    // Newest lists replace slide DOM after initial Swiper init.
    // Ensure sliders reflect the new slides.
    box.querySelectorAll(".js-popular-products-slider").forEach((sliderEl) => {
      if (sliderEl.swiper && typeof sliderEl.swiper.update === "function") {
        sliderEl.swiper.update();
      } else {
        initSliders(box);
      }
    });
  });

  window.addEventListener("resize", onResize);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
  });
})();
